<template>
  <footer>
    <div class="footer">
      <div class="footer-header total-width">
        <img src="../assets/images/footer_logo.png" />
        <div class="footer-header-image">
          <img src="../assets/images/footer/pic_KK1.png" />
        </div>
      </div>
      <div class="footer-content total-width">
        <ul class="left-nav">
          <li v-for="(item, index) in lData" :key="index">
            <h3>{{ item.title }}</h3>

            <p v-for="(el, num) in item.cList" :key="num" @click="skipLink(el)">
              {{ el.title }}
            </p>
          </li>
        </ul>
        <div class="right-nav">
          <h3>{{ rData.title }}</h3>
          <div class="right-nav-grid">
            <div
              class="right-nav-grid-content"
              v-for="(el, num) in rData.cList"
              :key="num"
            >
              <img
                class="right-nav-grid-content__icon"
                :src="el.icon"
                :alt="el.title"
              />
              <p>{{ el.title }}</p>
              <div class="right-nav-grid-content__qr">
                <img :src="el.qr" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="footer-decorate"
        src="../assets/images/footer/bg.png"
        alt=""
      />
      <div class="footer-bottom">
        <p>郑州市金水区文化路与黄河路交叉口向南300米路西库课科技大厦</p>
        <p>服务热线：400-6529-888</p>
        <p>
          Copyright ©2019-2025 库课科技集团股份有限公司 版权所有 网站地图
          <a
            class="footer-bottom-link"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            >豫ICP备16025169号</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { footerData } from "@/common/util/data.js";

export default {
  data() {
    return {
      ...footerData,
    };
  },
  methods: {
    skipLink(el) {
      if (el.title === "库课网校") {
        window.open(el.link);
      } else {
        this.$router.push(el.link);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  position: relative;
  background-color: #cd3324;

  &-header {
    display: flex;
    padding: 90px 0 60px;
    position: relative;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ffffff21;

    img {
      width: 298px;
      height: 54px;
    }

    &-image {
      position: absolute;
      margin-top: -100px;
      right: 0;

      img {
        width: auto;
        height: 275px;
      }
    }
  }

  .footer-content {
    margin: 0 auto;
    padding-top: 60px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 10;
    .left-nav {
      display: flex;
      justify-content: space-between;
      flex: 0 0 55%;
      li {
        margin-right: 3px !important;
        width: 150px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        h3 {
          margin-bottom: 33px;
          font-size: 20px;
          color: #ffffff;
        }
        p {
          display: inline-block;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          line-height: 36px;
          opacity: 0.6;
        }
      }
    }
    .right-nav {
      display: flex;
      flex-direction: column;

      h3 {
        margin-bottom: 24px;
        font-size: 20px;
        color: #ffffff;
      }

      .right-nav-grid {
        display: grid;
        grid-template-rows: repeat(3, 88px);
        grid-template-columns: 180px 1fr;

        .right-nav-grid-content {
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;

          &__icon {
            width: 48px;
            height: 48px;
          }

          p {
            padding-left: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            opacity: 0.6;
            width: 100px;
          }

          &__qr {
            position: absolute;
            left: -25px;
            opacity: 0;
            transition: opacity 0.3s;

            img {
              width: 100px;
              height: 100px;
            }
          }
        }

        .right-nav-grid-content:hover .right-nav-grid-content__qr {
          opacity: 1;
        }
      }
    }
  }

  &-decorate {
    position: relative;
    margin-top: -36px;
    width: 100%;
    height: 156px;
    object-fit: cover;
    z-index: 1;
  }

  &-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 128px;
    background: #b11000;

    p,
    .footer-bottom-link {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      opacity: 0.6;
    }

    .footer-bottom-link {
      opacity: 1;
    }
  }
}

@media screen and (min-width: 1920px) {
  .footer {
    .footer-content {
      .left-nav {
        li {
          margin-right: 10px !important;
        }
      }
    }
    .right-nav {
      .right-nav-grid {
        grid-template-columns: 196px 1fr !important;
      }
    }
  }
}
</style>
